import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';

import axios from 'axios';

export default class CreateTagModal extends React.Component {
  static propTypes = {
    currentTags: PropTypes.array.isRequired,
    databaseId: PropTypes.number.isRequired,
    modalDisplay: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    onUpdateTags: PropTypes.func.isRequired
  }

  state = {
    saveDisabled: true,
    tagData: ''
  }

  validTagLength = (tag) => {
    return tag.length >= 3;
  }

  tagExists = (tag) => {
    const { currentTags } = this.props;
    return currentTags.includes(tag.toLowerCase());
  }

  invalidTag = (tag) => {
    return !this.validTagLength(tag) || this.tagExists(tag);
  }

  handleHasTagData = (e) => {
    const tagData = e.target.value;
    this.setState({
      tagData: tagData,
      saveDisabled: this.invalidTag(tagData)
    });
  }

  disableSave = () => {
    this.setState({
      saveDisabled: true
    });
  }

  handleSave = () => {
    const { databaseId, onCloseModal, onUpdateTags } = this.props;
    const { tagData } = this.state;

    return axios.post(`/database_settings/${databaseId}/tags`, {
      tag: {
        name: tagData,
        database_id: databaseId
      }
    }).then((response) => {
      onUpdateTags(response.data);
      onCloseModal();
      this.disableSave();
    }).catch((errors) => {
      this.setState({ errors });
    });
  }

  renderTagForm = () => {
    return (
      <div>
        <label className="label-light">Tag Name</label>
        <div className="form-input-container">
          <input
            className="form-control"
            name="name"
            placeholder="Enter a tag name"
            onChange={this.handleHasTagData}
          />
        </div>
      </div>
    );
  }

  renderTagFooter = () => {
    const { onCloseModal } = this.props;
    const { saveDisabled, tagData } = this.state;

    return (
      <div className="mt-2">
        {
          (this.validTagLength(tagData) && this.tagExists(tagData))
           && <div className="text-muted mb-2 fs-small">This tag already exists</div>
        }
        <button className="btn btn-ghost" name="cancel" onClick={onCloseModal}>
          Cancel
        </button>
        <button className="btn btn-primary" disabled={saveDisabled} name="save" onClick={this.handleSave}>
          Save
        </button>
      </div>
    );
  }

  renderCreateTagModal = () => {
    const { modalDisplay, onCloseModal } = this.props;

    return (
      <Modal
        name="tag-form-modal"
        show={modalDisplay}
        onHide={onCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create a new tag</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {this.renderTagForm()}
          </div>
          <div className="mt-2">
            {this.renderTagFooter()}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    return (
      <div>
        {this.renderCreateTagModal()}
      </div>
    );
  }
}
